import { UI_PRIMITIVES } from '@/core/constants/uiColors';
import CalendarSvg from '@assets/images/svg/calendar.svg';
import React from 'react';
import { View } from 'react-native';

export interface CalendarIconProps {
    size?: number;
    color?: string;
}

export function CalendarIcon({ size = 20, color = UI_PRIMITIVES.bluePrimary }: CalendarIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CalendarSvg width={size} height={size} color={color} />
        </View>
    );
}

export default CalendarIcon;
